const mudEnter = () => import(/* webpackChunkName: "tideng-gemini-enter" */ '@/pages/tideng/mud/enter.vue');

export default [
  {
    path: '/mud/enter*',
    name: 'mudEnter',
    component: mudEnter,
    meta: {
      title: '提灯春节mud'
    }
  }
];



// WEBPACK FOOTER //
// ./src/router/tideng/mud.js